import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [
  	createPersistedState({
  		filter: (mutation) => {
  			return mutation.type === 'setPreference';
  		},

  		reducer: (state) => {
  			return {
  				Code: {
  				  mode: state.Code.mode,
            deletePassword: state.Code.deletePassword,
  				  theme: state.Code.theme,
  				  lineNumbers: state.Code.lineNumbers,
  				  lineWrapping: state.Code.lineWrapping,
  				  lineHeight: state.Code.lineHeight,
  				  fontSize: state.Code.fontSize,
  				}
  			};
  		}
  	})
  ]
})
